export default {"src":"/_next/static/media/MenuWhite.fc238c83.svg","height":18,"width":24};